'use client'

import { ext } from '@/utils/linkTarget'
import titleCase from '@/utils/titleCase'
import Container from '@/components/templates/container'

const Testimonial = ({ quote, name, nationality, activity }) => (
  <figure className="m-0 flex flex-col">
    <blockquote className="m-0 font-ttDrugsTrial text-olive text-[20px] md:text-[22px] leading-normal">
      &ldquo;{quote}&rdquo;
    </blockquote>
    <figcaption className="mt-6 font-chivoMono text-[13px] text-khaki">
      {name}
      {nationality ? `, ${nationality}` : ''}
      {activity ? ` · ${activity}` : ''}
    </figcaption>
  </figure>
)

// band: show the section on a full-width dune background
const TestimonialsSection = ({ testimonials, googleReviewUrl, reviewCtaText, heading, band = false }) => {
  const hasTestimonials = testimonials?.length > 0
  if (!hasTestimonials && !googleReviewUrl) return null

  return (
    <Container outerClassName={band ? 'bg-dune py-[100px] lg:py-[120px]' : 'my-[100px] lg:my-[130px]'}>
      {heading && (
        <h2 className="font-ttDrugsTrial text-olive text-[30px] md:text-[40px] leading-tight mb-12 lg:mb-16">{titleCase(heading)}</h2>
      )}

      {hasTestimonials && (
        <div className="flex md:grid md:grid-cols-3 gap-12 md:gap-y-16 lg:gap-x-14 overflow-x-auto md:overflow-visible scrollbar-hidden snap-x">
          {testimonials.map((t) => (
            <div key={t._id} className="shrink-0 w-[80vw] md:w-auto snap-start">
              <Testimonial quote={t.quote} name={t.name} nationality={t.nationality} activity={t.activity} />
            </div>
          ))}
        </div>
      )}

      <div className={`mt-14 lg:mt-[72px] pt-8 border-t ${band ? 'border-khaki/30' : 'border-dune'} flex flex-wrap items-center justify-between gap-4`}>
        <p className="font-chivoMono text-bodyMobile md:text-bodyDesktop text-umber">
          {reviewCtaText || 'Enjoyed your time at Mahima?'}
        </p>
        {googleReviewUrl && (
          <a
            href={googleReviewUrl}
            {...ext(googleReviewUrl)}
            className="pb-1 border-b border-olive font-chivoMono text-olive text-[13px] uppercase tracking-widest hover:text-umber hover:border-umber transition-colors"
          >
            Write a Google review
          </a>
        )}
      </div>
    </Container>
  )
}

export default TestimonialsSection
